import { invoke } from "@tauri-apps/api/core";
import { isTauri } from "@/lib/is-tauri";

export function logTtsPipeline(message: string): void {
  if (!isTauri() || import.meta.env.MODE === "test") return;
  void invoke("tts_pipeline_log", { msg: message }).catch(() => {});
}

/** Streamed replies whose first piece was logged, oldest first. */
const streamStartsLogged = new Set<string>();
const STREAM_STARTS_REMEMBERED = 64;

/**
 * Logs a streamed reply once per execution: each piece re-sends the whole
 * reply so far, and logging every one was a log write per token. The reply's
 * final length is logged when it ends.
 */
export function logTtsPipelineStreamStart(
  kind: string,
  executionId: string,
  textLength: number,
): void {
  const key = `${kind}:${executionId}`;
  if (streamStartsLogged.has(key)) return;
  streamStartsLogged.add(key);
  if (streamStartsLogged.size > STREAM_STARTS_REMEMBERED) {
    const oldest = streamStartsLogged.values().next().value;
    if (oldest !== undefined) streamStartsLogged.delete(oldest);
  }
  logTtsPipeline(`${kind} execution_id=${executionId} text_len=${textLength}`);
}
